var filtersConfig = {
    searchTitle: '',
    searchFoundComplex: ''
}
$(function () {
    // Глобальная функция для обновления видимости типов недвижимости
    function updatePropertyTypesVisibility() {
        console.log('Запуск принудительного обновления видимости типов недвижимости');
        
        // Проверяем URL страницы на наличие dubai-hills
        const currentUrl = window.location.href.toLowerCase();
        const isDubaiHillsByUrl = currentUrl.indexOf('dubai-hills') !== -1 || 
                                  currentUrl.indexOf('dubaihills') !== -1;
        
        // Прямая проверка значения атрибута
        const domainKeyValue = $('.filter').data('domain-key');
        const isDubaiHillsByAttr = domainKeyValue === 'dubai_hills' || domainKeyValue === 'dubai_hills_ru';
        
        // Если определено, что это Dubai Hills
        const isDubaiHills = isDubaiHillsByUrl || isDubaiHillsByAttr;
        console.log('Запущено обновление для типов. isDubaiHills:', isDubaiHills);
        
        if (isDubaiHills) {
            const allowedTypes = ["apartment", "villa", "townhouse", "duplex"];
            
            // Скрываем неразрешенные типы
            $('.type_select .select__option').each(function() {
                const optionValue = $(this).data('value');
                if (allowedTypes.indexOf(optionValue) === -1) {
                    $(this).hide();
                } else {
                    $(this).show();
                }
            });
        }
    }
    
    // Запускаем принудительное обновление через некоторое время после загрузки страницы
    setTimeout(updatePropertyTypesVisibility, 1000);
    
    // Также запускаем при изменении фильтров
    $(document).on('change', '.filter', function() {
        updatePropertyTypesVisibility();
    });
    
    // Запускаем каждые 2 секунды несколько раз для надежности
    for (let i = 0; i < 5; i++) {
        setTimeout(updatePropertyTypesVisibility, i * 2000);
    }

    // Проверка для Dubai Hills напрямую при загрузке
    $(document).ready(function() {
        // Ищем комментарий с debug info
        const debugComment = $('*:contains("Debug info: Domain configKey()")');
        const commentText = debugComment.length ? debugComment[0].textContent : '';
        console.log('Debug comment text:', commentText);
        
        // Проверяем наличие классов
        const hasDubaiHillsClass = $('.filter-dubai-hills').length > 0 || $('.filter-dubai-hills-ru').length > 0;
        console.log('Has Dubai Hills classes:', hasDubaiHillsClass);
        
        // Проверяем URL страницы
        const currentUrl = window.location.href.toLowerCase();
        const isDubaiHillsByUrl = currentUrl.indexOf('dubai-hills') !== -1 || 
                                 currentUrl.indexOf('dubaihills') !== -1;
        console.log('Is Dubai Hills by URL:', isDubaiHillsByUrl, 'URL:', currentUrl);
        
        // Проверяем содержимое комментария
        const isDubaiHillsByComment = commentText.indexOf('dubai_hills') !== -1;
        console.log('Is Dubai Hills by comment:', isDubaiHillsByComment);
        
        // Прямая проверка значения атрибута
        const domainKeyValue = $('.filter').data('domain-key');
        console.log('Domain Key Value:', domainKeyValue);
        const isDubaiHillsByAttr = domainKeyValue === 'dubai_hills' || domainKeyValue === 'dubai_hills_ru';
        console.log('Is Dubai Hills by attribute:', isDubaiHillsByAttr);
        
        // Если это Dubai Hills домен по любому из признаков
        if (hasDubaiHillsClass || isDubaiHillsByComment || isDubaiHillsByUrl || isDubaiHillsByAttr) {
            console.log('Это Dubai Hills домен, фильтруем типы недвижимости в инициализации');
            const allowedTypes = ["apartment", "villa", "townhouse", "duplex"];
            
            // Скрываем неразрешенные типы
            $('.type_select .select__option').each(function() {
                const optionValue = $(this).data('value');
                console.log('Тип недвижимости (глобальная проверка):', optionValue, 'разрешен:', allowedTypes.indexOf(optionValue) !== -1);
                if (allowedTypes.indexOf(optionValue) === -1) {
                    $(this).hide();
                }
            });
            
            // Дополнительно - если выбран неразрешенный тип, сбрасываем его
            if ($('.type_select .select__option_checked').length) {
                const selectedType = $('.type_select .select__option_checked').data('value');
                if (allowedTypes.indexOf(selectedType) === -1) {
                    console.log('Сбрасываем неразрешенный выбранный тип:', selectedType);
                    // Находим первый разрешенный тип и выбираем его
                    const firstAllowedOption = $('.type_select .select__option').filter(function() {
                        return allowedTypes.indexOf($(this).data('value')) !== -1;
                    }).first();
                    
                    if (firstAllowedOption.length) {
                        $('.type_select .select__option_checked').removeClass('select__option_checked');
                        firstAllowedOption.addClass('select__option_checked');
                    }
                }
            }
        }
    });

    function filterStart(currentFilter) {
        var currency = whitewillConfig.defaultCurrencyCode;
        var filter = {
            el: currentFilter,
            type_select: $(currentFilter).find('.type_select'),
            rooms_select: $(currentFilter).find('.rooms_select'),
            price_range: $('.price_range'),
            price_range_mobile: $('.price_range_mobile'),
            price_range_complex: $(currentFilter).find('.price_range_complex'),
            search_string: $(currentFilter).find('.search_string'),
            trigger_btn: $(currentFilter).find('.filter_btn'),
            results: $(currentFilter).find('.filter-results').length ? $(currentFilter).find('.filter-results') : $('#filter-results'),
            total: $('.filter__found-count'),
            sort: $('#sort__select_search'),
            sort_complex: $('#sort__select_search_complex'),
            filterMap: $(currentFilter).find('.filter-map'),
            metaTotalSelector: 'meta[name="total-objects"]',
            metaTotalTextSelector: 'meta[name="total-objects-text"]',
            floor_range: $('.more-options__floors'),
            area_range: $('.more-options__area'),
            decoration: $('.more-options_decoration'),
            date: $('.more-options_date'),
            ready: $('.more-options_ready'),
            secondary: $('.more-options_secondary'),
            options: $('.more-options_options'),
            complex_options: $('.more-options_complex_options'),
            complex_filter: $(currentFilter).find('.search_id_complex'),
            dropdown: $(currentFilter).find('.filter__panel-input-search-dropdown'),
            dropdownList: $(currentFilter).find('.filter__panel-input-search-dropdown-suggestions'),
            data: {
                type: null,
                rooms: [],
                price: [],
                date: [],
                ready: null,
                secondary: null,
                options: [],
                complex_options: [],
                price_complex: [],
                search: '',
                sortDirection: null,
                sortType: null,
                floor: [],
                area: [],
                area_m2: [],
                decoration: [],
                sort_complex: [],
                complex_filter: [],
            },
            filterNames: {
                type: 'kind/str_filter',
                rooms: 'rooms/int_multiple_band_filter',
                price: 'price_' + currency + '/int_band_filter',
                price_complex: 'complex_price_' + currency + '/custom',
                floor: 'floor/int_band_filter',
                area: 'area/int_band_filter',
                area_m2: 'area_m2/int_band_filter',
                decoration: 'decoration/str_multiple_filter',
                date: 'readiness_year/str_multiple_filter',
                ready: 'isbuilt/bool_filter',
                secondary: 'secondary/bool_filter',
                options: 'option_{value}_exist/bool_filter',
                complex_options: 'complex_option_{value}_exist/bool_filter',
                sort_complex: 'sort_complex/custom',
                complex_filter: 'complex_id/int_multiple_filter',
            },
            init() {
                if (this.el.length === 0) {
                    return false;
                }

                // Проверяем наличие классов для определения домена
                console.log('Filter classes:', this.el.attr('class'));
                
                const isDubaiHills = this.el.hasClass('filter-dubai-hills') || this.el.hasClass('filter-dubai-hills-ru');
                console.log('isDubaiHills по классам:', isDubaiHills);
                
                // Дополнительная проверка через data-атрибут для отладки
                console.log('data-domain-key:', this.el.data('domain-key'));
                const isDubaiHillsByData = this.el.data('domain-key') === 'dubai_hills' || this.el.data('domain-key') === 'dubai_hills_ru';
                console.log('isDubaiHills по data-domain-key:', isDubaiHillsByData);
                
                // Используем хотя бы один из методов определения
                const isDubaiHillsFinal = isDubaiHills || isDubaiHillsByData;
                console.log('Итоговое isDubaiHills:', isDubaiHillsFinal);

                if (isDubaiHillsFinal && this.type_select.length) {
                    const allowedTypes = ["apartment", "villa", "townhouse", "duplex"];
                    
                    console.log('Фильтруем типы недвижимости для dubai_hills');
                    this.type_select.find('.select__option').each(function() {
                        const optionValue = $(this).data('value');
                        console.log('Тип недвижимости:', optionValue, 'разрешен:', allowedTypes.indexOf(optionValue) !== -1);
                        if (allowedTypes.indexOf(optionValue) === -1) {
                            $(this).hide();
                        }
                    });
                }

                if(this.sort_complex.length) {
                    this.sort_complex.custom_select('onUpdate', (select) => {
                        this.data.sort_complex[0] = select.value;
                        this.data.sort_complex[1] = select.el.find('.select__option_checked')
                            .data('direction');
                        this.updatedData();
                    });
                }
                if (this.decoration.length){
                    this.data.decoration = this.decoration.checkbox_list('value');
                    this.decoration.checkbox_list('onUpdate', (checkbox_list) => {
                        if (checkbox_list.type == 'decorations') {
                            this.data.decoration = checkbox_list.value;
                            this.updatedData();
                        }
                    });
                }
                if (this.date.length){
                    this.data.date = this.date.checkbox_list('value');
                    this.date.checkbox_list('onUpdate', (checkbox_list) => {
                        if (checkbox_list.type == 'date') {
                            this.data.date = checkbox_list.value;
                            this.updatedData();
                        }
                    });
                }
                if (this.ready.length){
                    this.data.ready = this.ready.checkbox_list('value');
                    this.ready.checkbox_list('onUpdate', (checkbox_list) => {
                        if (checkbox_list.type == 'ready') {
                            this.data.ready = checkbox_list.value;
                            this.updatedData();
                        }
                    });
                }

                if (this.secondary.length){
                    this.data.secondary = this.secondary.checkbox_list('value');
                    this.secondary.checkbox_list('onUpdate', (checkbox_list) => {
                        if (checkbox_list.type == 'secondary') {
                            this.data.secondary = checkbox_list.value;
                            this.updatedData();
                        }
                    });
                }

                if (this.options.length){
                    this.data.options = this.options.checkbox_list('value');
                    this.options.checkbox_list('onUpdate', (checkbox_list) => {
                        if (checkbox_list.type == 'options') {
                            this.data.options = checkbox_list.value;
                            this.updatedData();
                        }
                    });
                }
                if (this.complex_options.length){
                    this.data.complex_options = this.complex_options.checkbox_list('value');
                    this.complex_options.checkbox_list('onUpdate', (checkbox_list) => {
                        if (checkbox_list.type == 'complex_options') {
                            this.data.complex_options = checkbox_list.value;
                            this.updatedData();
                        }
                    });
                }
                // Если у фильтра в DOM установлен выбранный комплекс, в котором ищем лоты
                if (this.el.attr('data-selected-complex') && this.el.attr('data-selected-complex').length) {
                    var complexId = this.el.data('selected-complex');
                    this.data.complex_filter.push(complexId)
                }
                if (this.type_select.length){
                    this.data.type = this.type_select.custom_select('value');
                    this.type_select.custom_select('onUpdate', (select) => {
                        this.data.type = select.value;
                        this.updatedData();
                    });
                }
                if (this.floor_range.length){
                    this.data.floor = this.floor_range.custom_select('value');
                    this.floor_range.custom_select('onUpdate', (select) => {
                        this.data.floor = select.value;
                        this.updatedData();
                    });
                }
                if (this.area_range.length){
                    let area = this.area_range.custom_select('value');

                    if (this.el.data('isRu')) {
                        this.data.area_m2 = area;
                    } else {
                        this.data.area = area;
                    }
                    this.area_range.custom_select('onUpdate', (select) => {
                        let value = select.value;

                        if (this.el.data('isRu')) {
                            this.data.area_m2 = value;
                        } else {
                            this.data.area = value;
                        }
                        this.updatedData();
                    });
                }
                if (this.rooms_select.length){
                    this.data.rooms = this.rooms_select.checkbox_list('value');
                    this.rooms_select.checkbox_list('onUpdate', (checkbox_list) => {
                        if (checkbox_list.type == 'rooms') {
                            this.data.rooms = checkbox_list.value;
                            this.updatedData();
                        }
                    });
                }

                if(this.price_range.length){
                    this.data.price = this.price_range.custom_select('value');
                    this.price_range.custom_select('onUpdate', (select) => {
                        this.data.price = select.value;
                        this.updatedData();
                    });
                }

                if(this.price_range_mobile.length){
                    this.data.price = this.price_range_mobile.custom_select('value');
                    this.price_range_mobile.custom_select('onUpdate', (select) => {
                        this.data.price = select.value;
                        this.updatedData();
                    });
                }

                if(this.price_range_complex.length){
                    this.data.price_complex = this.price_range_complex.custom_select('value');
                    this.price_range_complex.custom_select('onUpdate', (select) => {
                        this.data.price_complex = select.value;
                        this.updatedData();
                    });
                }

                if (this.search_string.length){
                    this.data.search = this.search_string.val();
                    this.search_string.on('input', e => {
                        clearTimeout(this.search_string.timeoutId);

                        this.search_string.timeoutId = setTimeout(() => {
                            this.data.search = this.search_string.val();
                            this.filter_change_handle();
                            this.postFilter(true);
                        }, 500);

                        if (!this.dropdownList.is(':empty')) {
                            this.dropdown.slideDown('fast');
                        }
                    })
                    this.search_string.on('click', e => {
                        if (!this.dropdownList.is(':empty')) {
                            this.dropdown.slideToggle('fast');
                        }
                    })
                }

                if (this.complex_filter.length){
                    this.data.complex_filter = this.complex_filter.checkbox_list('value');
                    this.complex_filter.checkbox_list('onUpdate', (checkbox_list) => {
                        if (checkbox_list.type == 'complex_filter') {
                            this.data.complex_filter = checkbox_list.value;
                            this.updatedData();
                        }
                    });
                }

                if(this.sort.length) {
                    this.sort.custom_select('onUpdate', (select) => {
                        this.data.sortType = select.value;
                        this.data.sortDirection = select.el.find('.select__option_checked')
                        .data('direction');
                        this.updatedData();
                    });
                }

                this.trigger_btn.on('click', e => {
                    if(this.results.length) {
                        this.postFilter();
                    } else {
                        var searchParams = new URLSearchParams(window.location.search),
                        url = new URL(this.trigger_btn.data('search-page-url'));

                        url.search = searchParams.toString();
                        window.location.href = url.toString();
                    }
                });

                this.setTotal();
            },
            updatedData() {
                this.filter_change_handle();
                this.postFilter();
            },
            getData() {
                console.log(this.data)
            },
            setTotal() {
                this.total.text($(this.metaTotalSelector).attr('content'));
                $('#more-options-show').text($(this.metaTotalTextSelector).attr('content'));
            },
            filter_change_handle() {
                var filters = this.data,
                    preparedFilters = new Map();

                // Проверяем наличие классов для определения домена
                const isDubaiHills = this.el.hasClass('filter-dubai-hills') || this.el.hasClass('filter-dubai-hills-ru');
                const isDubaiHillsByData = this.el.data('domain-key') === 'dubai_hills' || this.el.data('domain-key') === 'dubai_hills_ru';
                const isDubaiHillsFinal = isDubaiHills || isDubaiHillsByData;
                
                console.log('filter_change_handle - isDubaiHillsFinal:', isDubaiHillsFinal);
                
                const allowedTypes = ["apartment", "villa", "townhouse", "duplex"];

                // Если выбран тип, который не разрешен в dubai_hills, сбрасываем его
                if (isDubaiHillsFinal && filters.type && allowedTypes.indexOf(filters.type) === -1) {
                    console.log('Сбрасываем неразрешенный тип:', filters.type);
                    filters.type = null;
                }

                for (var key in filters) {
                    if (key == 'price' || key == 'price_complex') {
                        for (var i in filters[key]) {
                            filters[key][i] = filters[key][i].replace(/\s/g, '');
                        }
                    }
                    if(key === undefined || filters[key] === undefined || filters[key] === null) {
                        continue;
                    }

                    var filterName = this.filterNames[key];

                    if(filterName === undefined) {
                        continue;
                    }

                    if( Array.isArray(filters[key]) && !(filterName.indexOf('{value}') !== -1) ) {
                        if(!filters[key].length) {
                            continue;
                        }

                        var delimiter = ':';

                        if(filterName.indexOf('int_multiple_band_filter') !== -1) {
                            delimiter = ',';
                        }

                        preparedFilters.set(filterName, filters[key].join(delimiter));
                    } else {
                        preparedFilters.set(filterName, filters[key]);
                    }
                }

                var filtersStr = '';
                preparedFilters.forEach(function (value, key) {

                    if(key.indexOf('{value}') !== -1) {

                        if ( Array.isArray(value) ) {

                            if ( value.length ) {
                                filtersStr += 'begin_or_group;';
                                value.forEach(function (fkey, i) {
                                    filtersStr += key.replace('{value}', fkey) + '|1;';
                                });
                                filtersStr += 'end_or_group;';
                            }

                        } else {

                            filtersStr += key.replace('{value}', value) + '|1;';

                        }

                    }else if (key.indexOf('isbuilt') !== -1 || key.indexOf('readiness_year') !== -1) {
                        return;
                    } else {
                        filtersStr += key + '|' + value + ';';
                    }
                });

                if (preparedFilters.get('isbuilt/bool_filter') !== undefined || preparedFilters.get('readiness_year/str_multiple_filter') !== undefined) {
                    filtersStr += 'begin_or_group;';
                    if (preparedFilters.get('isbuilt/bool_filter') !== undefined)
                        filtersStr += 'isbuilt/bool_filter|' + preparedFilters.get('isbuilt/bool_filter') + ';';
                    if (preparedFilters.get('readiness_year/str_multiple_filter') !== undefined)
                        filtersStr += 'readiness_year/str_multiple_filter|' + preparedFilters.get('readiness_year/str_multiple_filter') + ';';
                    filtersStr += 'end_or_group;';
                }



                var searchParams = new URLSearchParams(window.location.search);
                searchParams.set('filters', filtersStr);
                if (this.data.sortDirection !== null && this.data.sortType !== null) {
                    searchParams.set('sort_direction', this.data.sortDirection);
                    searchParams.set('sort_type', this.data.sortType);
                } else {
                    searchParams.delete('sort_direction');
                    searchParams.delete('sort_type');
                }

                if(this.data.search !== null && this.data.search.length) {
                    searchParams.set('search', this.data.search);
                } else {
                    searchParams.delete('search');
                }

                var url = new URL(window.location.href);
                url.search = searchParams.toString();

                if(this.filterMap.length) {
                    var mapUrl = new URL(this.filterMap.attr('data-items-url'));
                    mapUrl.search = searchParams.toString();
                    this.filterMap.attr('data-items-url', mapUrl.toString());
                }

                window.history.replaceState({}, document.title,  url.toString());
            },
            postFilter(suggestions = false) {
                var _this = this;
                var filterUrl = this.el.data('filter-url');
                filterUrl = new URL(filterUrl);

                var searchParams = new URLSearchParams(window.location.search);
                searchParams.delete('page');
                var filters = searchParams.get('filters')
                filters = (filters) ? filters.split(';') : []

                // Проверяем наличие классов для определения домена
                const isDubaiHills = this.el.hasClass('filter-dubai-hills') || this.el.hasClass('filter-dubai-hills-ru');
                const isDubaiHillsByData = this.el.data('domain-key') === 'dubai_hills' || this.el.data('domain-key') === 'dubai_hills_ru';
                const isDubaiHillsFinal = isDubaiHills || isDubaiHillsByData;
                
                console.log('postFilter - isDubaiHillsFinal:', isDubaiHillsFinal, 'filters:', filters);

                // Фильтрация для dubai_hills и dubai_hills_ru
                if (isDubaiHillsFinal) {
                    const allowedTypes = ["apartment", "villa", "townhouse", "duplex"];
                    
                    // Проверяем каждый фильтр
                    for (let i = 0; i < filters.length; i++) {
                        const filter = filters[i];
                        if (filter.indexOf('kind/str_filter') === 0) {
                            const value = filter.split('|')[1];
                            console.log('Проверяем тип:', value, 'разрешен:', allowedTypes.indexOf(value) !== -1);
                            if (allowedTypes.indexOf(value) === -1) {
                                // Удаляем неразрешенные типы недвижимости
                                console.log('Удаляем неразрешенный тип из фильтра:', filter);
                                filters.splice(i, 1);
                                i--;  // Корректируем индекс после удаления
                            }
                        }
                    }
                }

                // Если фильтр не пустой
                if (filters.length > 0)
                {
                    filters.forEach((filter, i) => {
                        var split = filter.split('|'),
                            name = split[0], // имя фильтра
                            value = split[1]; // значение фильтра

                        // Если присутствует выбранный комплекс data-selected-complex, добавляем к фильтру
                        if (name === this.filterNames.complex_filter)
                            value = value.split(':').concat(this.data.complex_filter).join(':')

                        if (name && value)
                            filters[i] = name + '|' + value
                    })
                }
                else
                {
                    // Если присутствует выбранный комплекс data-selected-complex, добавляем к фильтру
                    if (this.data.complex_filter.length > 0)
                        filters.push(this.filterNames.complex_filter + '|' + this.data.complex_filter.join(':'))
                }

                filters = filters.join(';');
                searchParams.set('filters', filters)
                filterUrl.search = searchParams.toString();

                $.ajax({
                    url: filterUrl,
                    method: 'get',
                    success: function (json) {
                        if ( json.count_text ) {
                            $('#more-options-show').text(json.count_text);
                        }
                        _this.results.html(json['html']);

                        if (json.hasOwnProperty('html')) {
                            _this.dropdownList.html(json['hints']);
                        }
                        fast_background.update(() => $(document).trigger('initSlider'));
                        _this.setTotal();

                        if (suggestions && json['suggestions']) {
                            var items = filter.complex_filter.find('.checkbox-list__item');
                            var ids = [];
                            items.each(function (){
                                $(this).removeClass('d-none');
                                var val = $(this).attr('data-value');
                                var mas = json['suggestions'];
                                if (!in_array(val, mas)) {
                                    $(this).addClass('d-none');
                                }
                            });
                        }

                        if(_this.filterMap.length && _this.filterMap.is(':visible')) {
                            if(_this.filterMap.data('filter-trigger') !== undefined) {
                                $(document).trigger(_this.filterMap.data('filter-trigger'));
                            }
                        }
                    }
                })
            }
        }
        filter.init();
    }
    $(document).mouseup(function (e) {
        var dropdown = $('.filter__panel-input-search-dropdown');
        var dropdownBlock = $('.filter__panel-dropdown');
        if (dropdownBlock.has(e.target).length === 0){
            dropdown.slideUp('fast');
        }
    });
    $(document).on('click', '.filter-complex_list', function() {
        getTitle();
    });
    $(document).ready(function() {
        getTitle();
    });
    function getTitle() {
        var searchComplex = $('#where-found');
        var mainTitle = $('.filter_search_title');
        if (filtersConfig.searchTitle == '')
            filtersConfig.searchTitle = mainTitle.html();
        if (filtersConfig.searchFoundComplex == '')
            filtersConfig.searchFoundComplex = searchComplex.text();
        var title = $('.filter-complex_list.checkbox-list__item_checked')
        if (title.length == 1) {
            mainTitle.html( whitewillConfig.translates.properties_in + ' ' +title[0].textContent);
            searchComplex.html(whitewillConfig.translates.in + ' '+title[0].textContent);
        } else {
            mainTitle.html(filtersConfig.searchTitle);
            searchComplex.text(filtersConfig.searchFoundComplex);
        }
    }
    function in_array(value, array) {
        for(var i=0; i<array.length; i++){
            if(value == array[i]) return true;
        }
        return false;
    }
    filterStart($('#filter'));
    filterStart($('#filter-sticky'));
});
